import { CustomFileUpload } from 'components/customFileUpload'
import { Information, Label, TextWrapper } from 'components/form/form.style'
import { SelectImage } from 'components/selectImage'
import { FileUploadUploadEvent } from 'primereact/fileupload'

interface ImageUploadSectionProps {
    title: string
    description?: string
    uploadDescription?: string
    onUpload: (event: FileUploadUploadEvent) => void // Adjust type based on the actual upload handler
    customImageOptions: any[]
    setCustomImageOptions: React.Dispatch<React.SetStateAction<any[]>>
    customImage: string | null
    setCustomImage: React.Dispatch<React.SetStateAction<string | null>>
    setUploadedImages: React.Dispatch<React.SetStateAction<any[]>>
    allowMultiple?: boolean // Optional prop to allow multiple uploads
}

export const ImageUploadSection: React.FC<ImageUploadSectionProps> = ({
    title,
    description,
    uploadDescription,
    onUpload,
    customImageOptions,
    setCustomImageOptions,
    customImage,
    setCustomImage,
    setUploadedImages,
    allowMultiple = false,
}: ImageUploadSectionProps) => (
    <>
        <TextWrapper>
            <Label>{title}</Label>
            {description && <Information>{description}</Information>}
        </TextWrapper>
        <CustomFileUpload onUpload={onUpload} setImageOptions={setCustomImageOptions} allowMultiple={allowMultiple} />
        {uploadDescription && (
            <TextWrapper>
                <Information>{uploadDescription}</Information>
            </TextWrapper>
        )}
        <SelectImage
            imageOptions={customImageOptions}
            setImageOptions={setCustomImageOptions}
            setUploadedImages={setUploadedImages}
            selectedImage={customImage}
            setSelectedImage={setCustomImage}
        />
        <hr />
    </>
)
